import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import PageLayout from '../components/PageLayout';

const TermsOfUse = () => {
  const { t } = useLanguage();
  const location = useLocation();

  // Set document title
  useEffect(() => {
    document.title = `${t('terms.title')} - ${t('app.title')}`;
  }, [t, location]);

  return (
    <PageLayout 
      title={t('terms.title')}
      subtitle={t('terms.subtitle')}
    >
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-6 sm:p-8 lg:p-10 border border-gray-200 dark:border-gray-600">
            <div className="prose prose-lg dark:prose-invert max-w-none">
              <div className="mb-6 p-4 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-lg">
                <p className="text-amber-800 dark:text-amber-200 font-semibold mb-2">
                  {t('terms.effectiveDate')}
                </p>
                <p className="text-amber-700 dark:text-amber-300 text-sm">
                  {t('terms.welcome')}
                </p>
              </div>

              <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">
                {t('terms.disclaimers.title')}
              </h2>
              
              <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-3">
                {t('terms.disclaimers.unofficialData.title')}
              </h3>
              <ul className="list-disc list-inside text-gray-600 dark:text-gray-300 mb-4 space-y-2">
                <li>{t('terms.disclaimers.unofficialData.item1')}</li>
                <li>{t('terms.disclaimers.unofficialData.item2')}</li>
                <li>{t('terms.disclaimers.unofficialData.item3')}</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-3">
                {t('terms.disclaimers.gameOwnership.title')}
              </h3>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                {t('terms.disclaimers.gameOwnership.content')}
              </p>

              <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">
                {t('terms.intellectualProperty.title')}
              </h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                {t('terms.intellectualProperty.content')}
              </p>

              <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">
                {t('terms.permittedUse.title')}
              </h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                {t('terms.permittedUse.content')}
              </p>

              <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">
                {t('terms.termination.title')}
              </h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                {t('terms.termination.content')}
              </p>

              <h2 className="text-2xl font-bold text-gray-800 dark:text-gray-100 mb-4">
                {t('terms.contact.title')}
              </h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                {t('terms.contact.content')}
              </p>
            </div>
          </div>
    </PageLayout>
  );
};

export default TermsOfUse;
